import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { tap } from 'rxjs';
import { ArcLegalFLEIDeclarationLine, ArcLegalFLEIDeclarationReportResponse } from 'src/app/models/declartion-report-responses/arc-legal-flei-declaration-report-response';
import { DeclarationLine, InsurerFilterResponse } from 'src/app/models/declartion-report-responses/declaration-report-response';
import { ExportFileType } from 'src/app/models/enums/report-type.enum';
import { TransactionType } from 'src/app/models/enums/transaction-type.enum';
import { ReportHistoryService } from 'src/app/services/report-history.service';
import { ReportService } from 'src/app/services/report.service';
import { AppConstants, FORMAT_ONLY_DATE, NO_RESULTS_FOUND, PagingConstant } from 'src/app/shared/constants/constants';
import { HttpBaseService } from 'src/app/shared/services/http-base.service';
import { Utility } from 'src/app/utils/utility';

@Component({
    selector: 'app-arc-legal-flei-declarations-report',
    templateUrl: './arc-legal-flei-declarations-report.component.html',
    styleUrl: './arc-legal-flei-declarations-report.component.scss',
    standalone: false
})

export class ArcLegalFleiDeclarationsReportComponent implements OnInit {

  @Input()
  covers: string[];

  @Input()
  insurers: InsurerFilterResponse[];

  @Input()
  provider: string;

  @Input()
  products: string[];

  @Input()
  dateFrom: Date;

  @Input()
  dateTo: Date;

  @Input()
  sourceDialog: ArcLegalFLEIDeclarationReportResponse;

  @Input()
  historyItemId: string;

  transactionType = TransactionType;
  allOptionTxt: string = 'All';
  notfound = '';
  pagingConstant = PagingConstant;
  pageSizeOptions: number[] = PagingConstant.pageSizeOptions;
  totalRows: number = 0;
  searchResults: ArcLegalFLEIDeclarationLine[] = [];
  result: any;
  dataSource = new MatTableDataSource<ArcLegalFLEIDeclarationLine>([]);
  public appConstants = AppConstants;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns = [
    'bordereauReference',
    'agencyName',
    'agencyNumber',
    'localSubProducersName',
    'localSubProducersNumber',
    'contractName',
    'contractNumber',
    //'schemeNumber', //Contract Number'
    'sectionName',
    'reportingPeriodStartDate', //date from
    'reportingPeriodEndDate', //date to
    'certificateNumber', //Policy Number    
    'inceptionDate', //Risk Inception Date    
    'expiryDate', //Risk Expiry Date
    'originalInceptionDate', //Original Inception Date
    'effectiveDateOfTransaction',
    'policyPurchaseDate',
    'policyIssuanceDate',
    'riskTransactionType',
    'transactionTypeOriginalPremiumEtc',
    'cancellationDate',
    'cancellationReason',
    'numberOfInstalments',
    'instalmentBasis',
    'policyDuration',
    'methodOfSale',
    'insuredFirstName',
    'insuredFullNameLastNameOrCompanyName', //Insured Full Name, Last Name or Company Name
    'insuredPolicyholderType',
    'isAReasonableAdjustmentRequired', //Is a  Reasonable Adjustment Required
    'identifiedLedBy', //Identified / Led By
    'health',
    'lifeEvent',
    'resilience',
    'capability',
    'reasonableAdustmentMade',
    'insuredAddress',
    'insuredPostcode',
    'insuredCountry',
    'locationOfRiskAddress', //Location of Risk, Address
    'locationOfRiskPostcode', //Location of Risk, Postcode
    'locationOfRiskCountry', //Location of risk - Country
    'numberOfBedrooms', //Number of Bedrooms
    'previousClaims',
    'referredToArc',
    'referralReference',
    'referralReason',
    'grossPremiumPaidThisTime', //Gross premium paid this time
    'commission', //Commission %
    'commissionAmount',
    'localSubProducersCommission', //Local sub producers commission %
    'localSubProducersCommissionAmount', //Local sub producers commission amount
    'otherFeesOrDeductionsDescription', //Other Fees or Deductions Description
    'otherFeesOrDeductionsAmount', //Other Fees or Deductions Amount
    'totalPaidToArc', //Total Paid to Arc (underwriter rate + IPT)
    'tax1JurisdictionCountryStateProvinceTerritory', //Tax 1 - Jurisdiction: Country, State, Province, Territory
    'tax1TaxType', //Tax 1 - Tax Type    
    'tax1AmountOfTaxablePremium', //Tax 1 - Amount of Taxable Premium //net premium
    'tax1', //Tax 1 - %
    'tax1Amount', //Tax 1 - Amount
  ];

  /**
   *
   */
  constructor(
    private readonly _reportService: ReportService,
    private readonly _httpService: HttpBaseService,
    private readonly _reportHistoryService: ReportHistoryService) {
  }

  get notFoundMessage() {
    return this.notfound;
  }

  ngOnInit(): void {
    if (this.sourceDialog != null) {
      let source = this.sortData(this.sourceDialog.declarationLines, '', 'asc');
      let cloneArray = source.slice();
      let data = source.splice(0, 10);
      this.sourceDialog.declarationLines = cloneArray;
      this.dataSource = new MatTableDataSource<ArcLegalFLEIDeclarationLine>(data);
      this.totalRows = this.sourceDialog.declarationLines.length;
    }
  }

  onSubmit() {
    this.resetTable();
    this.loadData();
  }

  resetTable() {
    this.dataSource = new MatTableDataSource<ArcLegalFLEIDeclarationLine>([]);
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = PagingConstant.pageSizeOptions[1];
    this.totalRows = 0;
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.sort.sortChange
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  checkNotFoundResults(totalRecords) {
    this.notfound = totalRecords === 0 ? NO_RESULTS_FOUND : '';
  }

  getTableStyle() {
    let display = this.totalRows == 0 ? 'none' : 'block';
    return {
      'display': display
    };
  }

  loadData() {
    const pageIndex = this.paginator.pageIndex;
    const pageSize = this.paginator.pageSize;
    const sortField = this.sort.active;
    const sortDirection = this.sort.direction;
    if (this.sourceDialog) {
      let source = this.sortData(this.sourceDialog.declarationLines, sortField, sortDirection);
      let cloneArray = source.slice();
      let data = source.splice(pageIndex * pageSize, pageSize);
      this.sourceDialog.declarationLines = cloneArray;
      this.dataSource = new MatTableDataSource<ArcLegalFLEIDeclarationLine>(data);
    }
    else {
      let covers = this.covers.filter((x: string) => x != this.allOptionTxt);
      let arrInsurerIds: string[] = [];
      let ids = this.insurers.map((x: { ids: string[] }) => x.ids);
      ids.forEach((x: string[]) => arrInsurerIds = arrInsurerIds.concat(x));

      if (covers.length == 0) {
        this.totalRows = 0;
        this.checkNotFoundResults(this.totalRows);
      }
      else {
        this._reportService.getArcLegalDeclarationReport(covers, arrInsurerIds, moment(this.dateFrom).format(FORMAT_ONLY_DATE), moment(this.dateTo).format(FORMAT_ONLY_DATE), sortField, sortDirection, pageIndex, pageSize)
          .subscribe((report) => {
            // this.response = report;
            // this.totalRows = report.total;
            this.searchResults = report.declarationLines;
            this.dataSource = new MatTableDataSource<ArcLegalFLEIDeclarationLine>(this.searchResults);
            this.totalRows = report.total;
            this.checkNotFoundResults(this.totalRows);
          })
      }
    }
  }

  export(type: ExportFileType) {
    let url: string = '';
    const fromMonth = Utility.getMonthName(this.dateFrom);
    const toMonth = Utility.getMonthName(this.dateTo);
    const fileName = fromMonth != toMonth
      ? `ArcLegalFLEIDeclarationReport ${fromMonth}_${toMonth}_${new Date().toLocaleDateString("en-UK")}`
      : `ArcLegalFLEIDeclarationReport ${toMonth}_${new Date().toLocaleDateString("en-UK")}`;

    if (!this.sourceDialog) {
      let covers = this.covers.filter((x: string) => x != this.allOptionTxt);
      let arrInsurerIds: string[] = [];
      let ids = this.insurers.map((x: { ids: string[] }) => x.ids);
      ids.forEach((x: string[]) => arrInsurerIds = arrInsurerIds.concat(x));
      let providers: string[] = [];
      providers.push(this.provider)
      let arrProductIds = this.products.filter((x: string) => x != this.allOptionTxt);

      if (covers.length > 0) {
        url = this._reportService.exportArcLegalFLEIDeclarationReport(covers, arrInsurerIds, moment(this.dateFrom).format(FORMAT_ONLY_DATE), moment(this.dateTo).format(FORMAT_ONLY_DATE),
          providers, arrProductIds, type);
      }
    }
    else {
      url = this._reportHistoryService.exportArcLegalFLEIDeclarationReport(this.historyItemId, type);
    }

    this._httpService.downloadFile(url).subscribe(
      (data: BlobPart) => {
        const blob = new Blob([data], { type: this.getContentType(type) });
        let fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.style.display = "none";
        link.href = fileURL;
        link.download = fileName;
        link.target = '_blank';
        link.click();

        setTimeout(() => {
          link.remove();
          window.URL.revokeObjectURL(fileURL);
        }, 100);
      }
    );
  }

  sortData(data: ArcLegalFLEIDeclarationLine[], sortField: string, sortDirection: string): ArcLegalFLEIDeclarationLine[] {
    if (sortDirection == 'asc') {
      switch (sortField) {
        case 'inceptionDate':
          data.sort((a: ArcLegalFLEIDeclarationLine, b: ArcLegalFLEIDeclarationLine) => {
            return (new Date(a.inceptionDate)).getTime() - (new Date(b.inceptionDate)).getTime()
          });
          break;
        case 'expiryDate':
          data.sort((a: ArcLegalFLEIDeclarationLine, b: ArcLegalFLEIDeclarationLine) => {
            return (new Date(a.expiryDate)).getTime() - (new Date(b.expiryDate)).getTime()
          });
          break;
        default:
          data.sort((a: ArcLegalFLEIDeclarationLine, b: ArcLegalFLEIDeclarationLine) => {
            return (new Date(a.inceptionDate)).getTime() - (new Date(b.inceptionDate)).getTime()
          });
      }
    }
    else {
      switch (sortField) {
        case 'inceptionDate':
          data.sort((a: ArcLegalFLEIDeclarationLine, b: ArcLegalFLEIDeclarationLine) => {
            return (new Date(b.inceptionDate)).getTime() - (new Date(a.inceptionDate)).getTime()
          });
          break;
        case 'expiryDate':
          data.sort((a: ArcLegalFLEIDeclarationLine, b: ArcLegalFLEIDeclarationLine) => {
            return (new Date(b.expiryDate)).getTime() - (new Date(a.expiryDate)).getTime()
          });
          break;
        default:
          data.sort((a: ArcLegalFLEIDeclarationLine, b: ArcLegalFLEIDeclarationLine) => {
            return (new Date(b.inceptionDate)).getTime() - (new Date(a.inceptionDate)).getTime()
          });
      }
    }
    return data;
  }

  getContentType(fileType: ExportFileType) {
    switch (fileType) {
      case ExportFileType.Pdf:
        return "application/pdf";

      case ExportFileType.Csv:
        return "text/csv";

      case ExportFileType.Excel:
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      default:
        return '';
    }
  }

  exportExcel() {
    this.export(ExportFileType.Excel);
  }

  exportCsv() {
    this.export(ExportFileType.Csv);
  }

  exportPdf() {
    this.export(ExportFileType.Pdf);
  }

}
